import type { PricingSelectorLabels } from '../../_content';

/**
 * Preis-/Laufzeit-Stammdaten für /preise. Reines Datenmodul (kein 'use client',
 * keine React-Imports) → von Client-Komponenten (Selector, Compare-Zellen)
 * gemeinsam nutzbar, ohne die RSC-Grenze aufzuweichen.
 */

export type Duration = 'two-weeks' | 'one-month' | 'three-months';
export type Tier = 'basis' | 'plus';

/**
 * Erstpreise in Euro je Paket × Laufzeit — aus dem gültigen Preisstand
 * (`@kit/preise/server`, geladen in `pricing-page.tsx`), nie aus einer
 * Konstanten. `null` = Preise gerade nicht abrufbar (Spec §4.3).
 */
export type PreisMatrix = Record<Tier, Record<Duration, number>>;

export const DURATION_DAYS: Record<Duration, number> = {
  'two-weeks': 14,
  'one-month': 30,
  'three-months': 90,
};

export const DURATIONS: Duration[] = ['two-weeks', 'one-month', 'three-months'];

export function durationLabel(
  d: Duration,
  labels: PricingSelectorLabels,
): string {
  if (d === 'two-weeks') return labels.durationLabels.twoWeeks;
  if (d === 'one-month') return labels.durationLabels.oneMonth;
  return labels.durationLabels.threeMonths;
}
